import { render, staticRenderFns } from "./AppDots.vue?vue&type=template&id=17ccae05&"
import script from "./AppDots.vue?vue&type=script&lang=js&"
export * from "./AppDots.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports